import { EventEmitter, Injectable, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@core/auth';
//import { ActionNeededComponent } from '@shared/components/action-needed/action-needed.component';
//import { ActionNeededInterface } from '@shared/components/action-needed/action-needed.interface';
//import { ApproveTermsNeededComponent } from '@shared/components/approve-terms-needed/approve-terms-needed.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';

@Injectable({
	providedIn: 'root'
})
export class ActionsService {

	//@Output() openActionNeededModal = new EventEmitter<ActionNeededInterface | null>();
	ref: DynamicDialogRef;

	constructor(public dialogService: DialogService, private router: Router) {

	}
}
